import styled from 'styled-components';
import { Line } from 'react-chartjs-2';

export const StyledSparklineWrapper = styled.div`
    width: 100px;
`